import { render, staticRenderFns } from "./ColumnInfo.vue?vue&type=template&id=395ffe6f&"
import script from "./ColumnInfo.vue?vue&type=script&lang=js&"
export * from "./ColumnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports